var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 7.5,
    stroke: "#F5B386"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C18.47 14 14 18.47 14 24C14 29.53 18.47 34 24 34C29.53 34 34 29.53 34 24C34 18.47 29.53 14 24 14ZM28.3 28.3C27.91 28.69 27.28 28.69 26.89 28.3L24 25.41L21.11 28.3C20.72 28.69 20.09 28.69 19.7 28.3C19.31 27.91 19.31 27.28 19.7 26.89L22.59 24L19.7 21.11C19.31 20.72 19.31 20.09 19.7 19.7C20.09 19.31 20.72 19.31 21.11 19.7L24 22.59L26.89 19.7C27.28 19.31 27.91 19.31 28.3 19.7C28.69 20.09 28.69 20.72 28.3 21.11L25.41 24L28.3 26.89C28.68 27.27 28.68 27.91 28.3 28.3Z",
    fill: "#EF8035"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.9ae6168f.svg";
export { ForwardRef as ReactComponent };